import React, { useState, useEffect } from 'react';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import GetUserId from 'Components/UserLogged/UserId/UserId';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import AnalyticsFilter from './AnalyticsFilter/AnalyticsFilter';
import AnalyticsListAssingment from './AnalyticsListAssingment/AnalyticsListAssingment';
import AnalyticsCharts from './AnalyticsGraphics/AnalyticsCharts';

const Analytics = () => {
    useEffect(() => {
        document.title = "Redech | Análise"
    }, [])

    const userIdLogged = GetUserId();
    const [sectorSelected, setSectorSelected] = useState(null);
    const [managerSelected, setManagerSelected] = useState(null);
    const [employeeSelected, setEmployeeSelected] = useState(null);
    const [sectorEmployees, setSectorsEmployees] = useState([]);

    const [resetFilterDay, setResetFilterDay] = useState(null);

    const [selectedActualDate, setSelectedActualDate] = useState();

    useEffect(() => {
        setSelectedActualDate(new Date());
    }, []);

    useEffect(() => {
        async function getSectorIdByLoggedEmployee() {
            if (userIdLogged) {
                const parameters = { userId: userIdLogged }
                const employeeData = await ExecuteAxios.api('get', `/employee/employee-by-userId/`, { params: parameters });
                if (employeeData && employeeData.length === 1) {
                    const sectorRow = employeeData[0].constructorList.find(item => item.field === 'sector');
                    const sector = sectorRow.argument;
                    if (sector) {
                        setSectorSelected(sector);
                    }
                }
            }
        };

        getSectorIdByLoggedEmployee();
    }, [userIdLogged])

    const informationGraphics = {
        flexDirection: 'row',
        display: 'flex',
        width: '100%',
        height: '100%'
    }

    const displayMain = {
        display: 'flex',
        flexDirection: 'row',
        minWidth: '100%',
        maxWidth: '100%'
    }

    return (
        <>
            <LayoutDefault>
                <Panel style={displayMain}>
                    <AnalyticsFilter
                        onUpdateSectorSelected={val => { setSectorSelected(val) }}
                        onUpdateManagerSelected={val => { setManagerSelected(val) }}
                        onUpdateEmployeeSelected={val => { setEmployeeSelected(val) }}
                        updateSectorsEmployees={val => { setSectorsEmployees(val) }}
                        onUpdateSelectedActualDate={val => { setSelectedActualDate(val) }}
                        selectedActualDate={selectedActualDate}
                        sectorSelected={sectorSelected}
                        managerSelected={managerSelected}
                        employeeSelected={employeeSelected}
                        sectorEmployees={sectorEmployees}
                    />
                    <AnalyticsListAssingment
                        onUpdateResetFilterDay={val => { setResetFilterDay(val) }}
                        resetFilterDay={resetFilterDay}
                        sectorSelected={sectorSelected}
                        managerSelected={managerSelected}
                        employeeSelected={employeeSelected}
                        selectedActualDate={selectedActualDate}
                    />
                    <Panel style={{
                        display: 'flex', flexDirection: 'column', minWidth: '40%',
                        maxWidth: '40%', height: '100%', borderLeft: '2px solid #ccc'
                    }}>
                        <Panel style={informationGraphics}>
                            <AnalyticsCharts
                                sectorSelected={sectorSelected}
                                managerSelected={managerSelected}
                                employeeSelected={employeeSelected}
                                selectedActualDate={selectedActualDate}
                            />
                        </Panel>
                    </Panel>
                </Panel>
            </LayoutDefault >
        </>
    );
};

export default Analytics;
